import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function PaymentAndCancellation() {
  return <section className="w-full bg-cream py-24 px-6" data-id="element-327">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-328">
        {/* Medios de pago */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl p-10 border border-teal/10 shadow-sm flex flex-col" data-id="element-329">
          <div className="mb-2 text-teal font-serif uppercase tracking-widest text-xs" data-id="element-330">
            Información práctica
          </div>
          <h2 className="font-serif text-teal-dark text-3xl md:text-4xl mb-8" data-id="element-331">
            Medios de pago
          </h2>

          <div className="space-y-8 flex-grow" data-id="element-332">
            <div data-id="element-333">
              <div className="flex items-center gap-3 mb-3" data-id="element-334">
                <span className="text-2xl" data-id="element-335">🇦🇷</span>
                <h3 className="font-serif text-teal-dark text-lg uppercase tracking-wider" data-id="element-336">
                  Si estás en Argentina
                </h3>
              </div>
              <p className="text-gray-700 font-light leading-relaxed pl-11" data-id="element-337">
                El pago se realiza en pesos argentinos por
                <span className="font-medium" data-id="element-338"> transferencia bancaria </span>o{' '}
                <span className="font-medium" data-id="element-339">Mercado Pago.</span>
              </p>
            </div>

            <div data-id="element-340">
              <div className="flex items-center gap-3 mb-3" data-id="element-341">
                <span className="text-2xl" data-id="element-342">🌎</span>
                <h3 className="font-serif text-teal-dark text-lg uppercase tracking-wider" data-id="element-343">
                  Si estás en otro país
                </h3>
              </div>
              <p className="text-gray-700 font-light leading-relaxed pl-11" data-id="element-344">
                El pago se realiza en dólares estadounidenses a través de
                <span className="font-medium" data-id="element-345"> PayPal.</span>
                <br data-id="element-346" />
                Al momento de agendar te envío el enlace de pago
                correspondiente.
              </p>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-teal/10" data-id="element-347">
            <p className="font-serif italic text-teal text-sm md:text-base leading-relaxed" data-id="element-348">
              En ambos casos, el pago debe estar acreditado antes de las 24
              horas previas a tu turno.
            </p>
          </div>
        </motion.div>

        {/* Política de cancelación */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="bg-white rounded-2xl p-10 border border-teal/10 shadow-sm flex flex-col" data-id="element-349">
          <div className="mb-2 text-teal font-serif uppercase tracking-widest text-xs" data-id="element-350">
            Justa para ambas partes
          </div>
          <h2 className="font-serif text-teal-dark text-3xl md:text-4xl mb-4" data-id="element-351">
            Política de cancelación
          </h2>
          <p className="text-gray-600 font-light italic mb-8" data-id="element-352">
            Entiendo que los imprevistos ocurren.
          </p>

          <div className="space-y-6 flex-grow" data-id="element-353">
            <div className="flex gap-4" data-id="element-354">
              <div className="flex-shrink-0 w-1 bg-teal rounded-full" data-id="element-355"></div>
              <div data-id="element-356">
                <h3 className="font-serif text-teal-dark text-base md:text-lg mb-1" data-id="element-357">
                  Más de 48 horas antes
                </h3>
                <p className="text-gray-700 font-light leading-relaxed text-sm md:text-base" data-id="element-358">
                  Reembolso completo — o crédito para reagendar cuando quieras.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-359">
              <div className="flex-shrink-0 w-1 bg-gold rounded-full" data-id="element-360"></div>
              <div data-id="element-361">
                <h3 className="font-serif text-teal-dark text-base md:text-lg mb-1" data-id="element-362">
                  Entre 48 y 24 horas antes
                </h3>
                <p className="text-gray-700 font-light leading-relaxed text-sm md:text-base" data-id="element-363">
                  El monto queda como crédito para usar en una futura sesión.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-364">
              <div className="flex-shrink-0 w-1 bg-gray-300 rounded-full" data-id="element-365"></div>
              <div data-id="element-366">
                <h3 className="font-serif text-teal-dark text-base md:text-lg mb-1" data-id="element-367">
                  Menos de 24 horas antes
                </h3>
                <p className="text-gray-700 font-light leading-relaxed text-sm md:text-base" data-id="element-368">
                  No se realizan reembolsos. La preparación del trabajo ya fue
                  iniciada.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-teal/10" data-id="element-369">
            <p className="font-serif italic text-teal text-sm md:text-base leading-relaxed" data-id="element-370">
              Si por alguna razón excepcional necesito cancelar de mi parte, te
              ofrezco reembolso completo o prioridad absoluta en el reagendado.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}